/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProvidedCouponCodesHalResponse } from '../../models/provided-coupon-codes-hal-response';
import { ProvidedCouponCodesPutRequest } from '../../models/provided-coupon-codes-put-request';

export interface CouponsCouponIdUserProvidedCodesPut$Params {
  'Active-Tenant-Identifier': string;
  couponId: string;
      body: ProvidedCouponCodesPutRequest
}

export function couponsCouponIdUserProvidedCodesPut(http: HttpClient, rootUrl: string, params: CouponsCouponIdUserProvidedCodesPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ProvidedCouponCodesHalResponse>> {
  const rb = new RequestBuilder(rootUrl, couponsCouponIdUserProvidedCodesPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('couponId', params.couponId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProvidedCouponCodesHalResponse>;
    })
  );
}

couponsCouponIdUserProvidedCodesPut.PATH = '/coupons/{couponId}/user-provided-codes';
